<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 17:41:45
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-13 15:11:12
-->
<template>
  <div class="serviceDisburseCell">
    <div>
      <div>团长服务费率：{{ row.disburse_commission_rate }}%</div>
      <div>预估支出：￥{{ row.disburse_estimated_commission }}</div>
      <div>实际支出：￥{{ row.disburse_real_commission }}</div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
export default {
  mixins: [mixin]
}
</script>
<style lang="less" scoped></style>
